// Created by Cedric on 12/5/11.
// vuex types

export const LOGIN = 'USER_LOGIN'
// user登陆／登出
export const SIGNIN = 'SIGN_IN'
export const SIGNOUT = 'SIGN_OUT'
// 重新赋值用户信息
export const RESIGN = 'SIGN_REPLACE'
// 设置导航
export const SLIDER = 'SET_SLIDER'
// 获取导航信息
export const NAVINFO = 'FETCH_NAV_INFO'
// 时间switcher
export const ACTIVETIME = 'FETCH_ACTIVE_TIME'
// 用户签约
export const ISSIGN = 'USER_SIGN'
export const SETFEE = 'SET_SERVICE_FEE'
// 选择网站的theme
export const CHANGETHEME = 'CHANGE_WEB_THEME'
// 保存table的查询条件
export const SETCONDITION = 'SET_TABLE_CONDITION'
// 用户的设备
export const AGENT = "USER_AGENT"
// coupon 签约
export const AGREECOUPON = "AGREE_COUPON"
// 修改语言
export const CHANGELANG = "CHANGE_LANG"

// trx页面 查询条件
export const SetTrxListTable = "SET_TRXLIST_TABLE"
export const InitTrxListTable = "INIT_TRXLIST_TABLE"

// refunds页面 查询条件
export const SetRefundTable = "SET_REFUNDS_TABLE"
export const InitRefundTable = "INIT_REFUNDS_TABLE"

// settlements页面 查询条件
export const SetSettleTable = "SET_SETTLE_TABLE"
export const InitSettleTable = "INIT_SETTLE_TABLE"

// accounts 页面查询条件
export const SetAccountTable = "SET_ACCOUNTS_TABLE"
export const InitAccountTable = "INIT_ACCOUNTS_TABLE"

// stores 页面查询条件
export const SetStoreTable = "SET_STORES_TABLE"
export const InitStoreTable = "INIT_STORES_TABLE"

// invoices 页面查询条件
export const SetInvoiceTable = "SET_INVOICES_TABLE"
export const InitInvoiceTable = "INIT_INVOICES_TABLE"



// WEBPACK FOOTER //
// ./src/store/types.js